import { cleApi } from "./client";
import type { DocumentAuditTrailModel } from "./models/documents";

export const getAuditTrailBySubjectId = (
  subjectId: string,
): Promise<DocumentAuditTrailModel[]> =>
  cleApi.get<DocumentAuditTrailModel[]>(`audit-trail/${subjectId}`);
